'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var accountId = exports.accountId = 53;

var debugKey = exports.debugKey = 'USAGE_TRACKER_JS';

var hstcKey = exports.hstcKey = '__hstc';

var hamplitudeKey = exports.hamplitudeKey = '__hmpl';

var storageKey = exports.storageKey = 'HUBLYTICS_EVENTS_' + accountId;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.74/js/storageKeys.js
// module id = 47
// module chunks = 0